"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUserStatus = exports.StyledOverlay = exports.StyledAvatar = exports.StyledAvatarImage = exports.StyledAvatarContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _oxygenUserStatus = _interopRequireDefault(require("@8x8/oxygen-user-status"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledAvatarContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: fit-content;\n  justify-content: flex-end;\n"])));

exports.StyledAvatarContainer = StyledAvatarContainer;

var StyledAvatar = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  width: ", ";\n  border-radius: 50%;\n  background: ", ";\n  svg {\n    fill: ", ";\n  }\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return theme["size".concat(size[0].toUpperCase() + size.slice(1))];
}, function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return theme["size".concat(size[0].toUpperCase() + size.slice(1))];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.avatarBackgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.placeholderIconColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.initialsColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.initialsFontFamily;
}, function (_ref7) {
  var theme = _ref7.theme,
      size = _ref7.size;
  return theme["font".concat(size[0].toUpperCase() + size.slice(1))];
});

exports.StyledAvatar = StyledAvatar;

var StyledOverlay = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  width: inherit;\n  position: absolute;\n  align-self: flex-end;\n  background: ", ";\n  opacity: 0.85;\n  svg {\n    fill: ", ";\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme,
      size = _ref8.size;
  return "calc(0.3 * ".concat(theme["size".concat(size[0].toUpperCase() + size.slice(1))], ")");
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.editOverlayColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.editIconColor;
}, function (_ref11) {
  var size = _ref11.size,
      theme = _ref11.theme;
  return size === '5xl' ? theme.editIconLargeSize : theme.editIconSmallSize;
}, function (_ref12) {
  var size = _ref12.size,
      theme = _ref12.theme;
  return size === '5xl' ? theme.editIconLargeSize : theme.editIconSmallSize;
});

exports.StyledOverlay = StyledOverlay;

var StyledAvatarImage = _styledComponents["default"].img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  object-fit: cover;\n"])), function (_ref13) {
  var theme = _ref13.theme,
      size = _ref13.size;
  return theme["size".concat(size[0].toUpperCase() + size.slice(1))];
}, function (_ref14) {
  var theme = _ref14.theme,
      size = _ref14.size;
  return theme["size".concat(size[0].toUpperCase() + size.slice(1))];
});

exports.StyledAvatarImage = StyledAvatarImage;
var StyledUserStatus = (0, _styledComponents["default"])(_oxygenUserStatus["default"])(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  align-self: flex-end;\n"])));
exports.StyledUserStatus = StyledUserStatus;